// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__ouBfw","carousel__item":"Carousel_carousel__item__ez3NE","carousel__items":"Carousel_carousel__items__3_olo"};